import { ThankyouComponent } from './../thankyou/thankyou.component';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import constants from '../../utility/constants';
import { MustMatch } from '../../core/validators/must-match.validator';
import {
  EventBusService,
  CountryService
} from '../../services';
import { BuyerService } from '../../services/buyer.service';
import messages from '../../utility/messages';
import {  Subscription } from 'rxjs';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css'],
})
export class RegistrationComponent implements OnInit {
  createForm: FormGroup;
  loading: boolean = false;
  countries: any;
  hide: boolean = true;
  hidep: boolean = true;
  isdFlagList: any;
  isd: number = 229;
  modal: Array<any>;
  private subscriptions: Array<Subscription> = [];
  phoneForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required]),
  });

  //Minimum eight characters, at least one uppercase letter, one lowercase letter and one number:
  patternHign: any = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[A-Za-z\\d@$!%*?&]{8,}$';
  emailHign: any = '[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}';
  constructor(
    private ebs: EventBusService,
    private modalService: BsModalService,
    private countryService: CountryService,
    private buyerService: BuyerService,
    private toastr: ToastrService,
    public formBuilder: FormBuilder,
    public modalRef: BsModalRef
  ) {}

  ngOnInit(): void {
    const allCountryFlagIsd = this.countryService.getAllCountryFlagIsd().subscribe((res) => {
      this.isdFlagList = res;
    });
    this.subscriptions.push(allCountryFlagIsd)
    const countries = this.countryService.getCountries().subscribe((res) => {
      this.countries = res;
    });
    this.subscriptions.push(countries)
    this.createForm = this.formBuilder.group(
      {
        firstName: new FormControl('', Validators.required),
        lastName: new FormControl('', Validators.required),
        email: new FormControl('', [
          Validators.required,
          Validators.pattern(this.emailHign),
        ]),
        mobileNumber: new FormControl('', [
          Validators.required,
          Validators.pattern('[a-zA-Z0-9.()-_,]{10,30}'),
        ]),
        isdCode: new FormControl(this.isd, Validators.required),
        company: new FormControl(''),
        street: new FormControl('', Validators.required),
        city: new FormControl('', Validators.required),
        country: new FormControl(229, Validators.required),
        state: new FormControl('', Validators.required),
        postalCode: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern('^[A-Za-z0-9-]+$'),
            Validators.maxLength(12),
          ])
        ),
        password: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern(this.patternHign),
          ])
        ),
        confirmPassword: new FormControl('', Validators.required),
      },
      {
        validators: MustMatch('password', 'confirmPassword'),
      }
    );
  }
  countryChangedEvent(event) {
    this.isd = event.dialCode;
  }
  hideAndReset() {
    this.modalRef.hide();
    this.createForm.reset();
  }
  submitCreateForm() {
    this.loading = true;
    let mobile = this.createForm
      .get('mobileNumber')
      .value.replace('+' + this.isd, '');
    this.createForm.patchValue({
      mobileNumber: String(
        this.createForm.get('mobileNumber').value.replace('+' + this.isd, '')
      ),
    });
    let modal = this.createForm.getRawValue();
    modal.mobileNumber = mobile;
    const register = this.buyerService.register(modal).subscribe(
      (res) => {
        this.toastr.success(
          messages.register.status,
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
        this.hideAndReset();
        let modalOptions: ModalOptions = {
          backdrop: 'static',
          keyboard: false,
          class: 'custom-popup user-login modal-dialog modal-dialog-centered',
        };
        this.loading = false;
        this.modalService.show(ThankyouComponent, modalOptions);
      },
      (err) => {
        this.loading = false;
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
        return false;
      }
    );
    this.subscriptions.push(register)
  }
  openModalFile(modalName: String) {
    this.ebs.notification.emit(modalName);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
